import { render, staticRenderFns } from "./GrabRender.vue?vue&type=template&id=c40118e8&scoped=true&"
import script from "./GrabRender.vue?vue&type=script&lang=ts&"
export * from "./GrabRender.vue?vue&type=script&lang=ts&"
import style0 from "./GrabRender.vue?vue&type=style&index=0&id=c40118e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c40118e8",
  null
  
)

export default component.exports